module.exports = __webpack_public_path__ + "img/java.1a49c5cd.png";